import React from 'react'
import { makeStyles, createStyles, Box, Typography, fade } from '@material-ui/core'
import classnames from 'classnames'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    root2: {
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2),
      },
    },
    noneMargin: {
      marginBottom: 0,
      paddingBottom: 0,
    },
    title: {
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(1),
    },
    secondaryBackground: {
      background: `linear-gradient(186.46deg, ${fade(theme.palette.secondary.main, 0.05)} 11.44%, ${fade(
        theme.palette.secondary.contrastText,
        0,
      )} 54.25%)`,
    },
    primaryBackground: {
      background: `linear-gradient(186.46deg, ${fade(theme.palette.primary.main, 0.1)} 11.44%, ${fade(
        theme.palette.secondary.contrastText,
        0,
      )} 54.25%)`,
    },
    radius: {
      borderRadius: 12,
    },
  }),
)

const InfoWrapper = ({ children, title, bgColor, className, radius, margin, titleVariant, isBooking }) => {
  const classes = useStyles()
  return (
    <Box bgcolor="background.paper" className={radius ? classes.radius : ''}>
      <Box
        className={classnames(className, {
          [classes.secondaryBackground]: bgColor === 'secondary',
          [classes.primaryBackground]: bgColor === 'primary',
          [classes.noneMargin]: margin === 'none',
          [classes.root2]: isBooking,
          [classes.root]: !isBooking,
        })}
      >
        {title && (
          <Typography className={classes.title} variant={titleVariant || 'h4'}>
            {title}
          </Typography>
        )}
        {children}
      </Box>
    </Box>
  )
}

export default InfoWrapper
